export enum ReminderEnum {
    SleepQ = 'sleepQ',
    SleepQFirstWarning = 'sleepQFirstWarning',
    SleepQFinalWarning = 'sleepQFinalWarning',
    TherapyConsent = 'therapyConsent',
    TherapyConsentFirstWarning = 'therapyConsentFirstWarning',
    TherapyConsentFinalWarning = 'therapyConsentFinalWarning',
    programCanceled = 'programCanceled',
    SleepDiary = 'sleepDiary',
    TherapySession = 'therapySession',
    PostQ = 'postQ',
    PostQWarning = 'postQWarning',
    SetupNotifications = 'setupNotifications'
}
